// Recovered compiled webpack factory 62234. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { Er: () => s, Mn: () => l });
  var n = r(21010),
    a = r(87624),
    o = r(16649),
    i = r(38599);
  let s = "__sentry_xhr_v3__";
  function l(e) {
    ((0, n.s5)("xhr", e), (0, n.AS)("xhr", u));
  }
  function u() {
    if (!i.j.XMLHttpRequest) return;
    let e = XMLHttpRequest.prototype;
    ((e.open = new Proxy(e.open, {
      apply(e, t, r) {
        let i = Error(),
          l = 1e3 * (0, a.zf)(),
          u = (0, o.Kg)(r[0]) ? r[0].toUpperCase() : void 0,
          c = (function (e) {
            if ((0, o.Kg)(e)) return e;
            try {
              return e.toString();
            } catch {}
          })(r[1]);
        if (!u || !c) return e.apply(t, r);
        ((t[s] = { method: u, url: c, request_headers: {} }),
          "POST" === u && c.match(/sentry_key/) && (t.__sentry_own_request__ = !0));
        let f = () => {
          let e = t[s];
          if (e && 4 === t.readyState) {
            try {
              e.status_code = t.status;
            } catch {}
            let r = { endTimestamp: 1e3 * (0, a.zf)(), startTimestamp: l, xhr: t, virtualError: i };
            (0, n.aj)("xhr", r);
          }
        };
        return (
          "onreadystatechange" in t && "function" == typeof t.onreadystatechange
            ? (t.onreadystatechange = new Proxy(t.onreadystatechange, {
                apply: (e, t, r) => (f(), e.apply(t, r)),
              }))
            : t.addEventListener("readystatechange", f),
          (t.setRequestHeader = new Proxy(t.setRequestHeader, {
            apply(e, t, r) {
              let [n, a] = r,
                i = t[s];
              return (
                i && (0, o.Kg)(n) && (0, o.Kg)(a) && (i.request_headers[n.toLowerCase()] = a),
                e.apply(t, r)
              );
            },
          })),
          e.apply(t, r)
        );
      },
    })),
      (e.send = new Proxy(e.send, {
        apply(e, t, r) {
          let o = t[s];
          if (!o) return e.apply(t, r);
          void 0 !== r[0] && (o.body = r[0]);
          let i = { startTimestamp: 1e3 * (0, a.zf)(), xhr: t };
          return ((0, n.aj)("xhr", i), e.apply(t, r));
        },
      })));
  }
}
